import { SelectType } from '../types';

export const findUfByLabel = (
  label: string,
  options: SelectType[],
): SelectType | undefined => options.find((uf) => uf.label === label);
